<div class="nt-empty" [attr.data-cy]="dataCy()">
  <span class="nt-empty__icon">
    <lkt-icon name="bell" [size]="34" [dataCy]="iconDataCy()" />
  </span>

  <p class="nt-empty__title">{{ title() }}</p>
  <p class="nt-empty__desc">{{ description() }}</p>

  @if (actionLabel()) {
    <button
      type="button"
      class="nt-empty__action"
      [attr.data-cy]="actionDataCy()"
      (click)="onAction()">
      {{ actionLabel() }}
    </button>
  }
</div>
